__turbopack_context__.v({
  "container": "VoiceInput-module__zBTreW__container",
  "error": "VoiceInput-module__zBTreW__error",
  "interimTranscript": "VoiceInput-module__zBTreW__interimTranscript",
  "listening": "VoiceInput-module__zBTreW__listening",
  "listeningIndicator": "VoiceInput-module__zBTreW__listeningIndicator",
  "pulse": "VoiceInput-module__zBTreW__pulse",
  "pulse-border": "VoiceInput-module__zBTreW__pulse-border",
  "pulse-dot": "VoiceInput-module__zBTreW__pulse-dot",
  "voiceButton": "VoiceInput-module__zBTreW__voiceButton",
});
